export default __webpack_public_path__ + "1af4c750da00bfbbcc4fdd01bc751c10.png";